import { gql } from '@apollo/client';

/** Billing webhook queue (`webhookQueues`). */
export const GET_WEBHOOK_QUEUES = gql`
  query GetWebhookQueues(
    $first: Int
    $after: String
    $where: WebhookQueueFilterInput
    $order: [WebhookQueueSortInput!]
  ) {
    webhookQueues(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        status
        provider
        attempts
        processedAt
        errorMessage
        createdAt
        updatedAt
        payload
        headers
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;
